import { useState } from "react";
import { LeftSideMenu } from "../../components/leftSideMenu/LeftSideMenu";
import { TabbedContent } from "../../components/tabs/TabbedContent";
import {
  CreationForm,
  CreationFormTemplate,
} from "../../components/form/CreationForm";
import DragDropInput from "../../components/form/DragDropInput";
import DataTable from "../../components/dataTables/DataTable";
import {
  useMedia,
  useOrder,
  useOrders,
  useProduct,
  useProducts,
} from "../../hooks";
import { buildColDefs } from "../../components/dataTables/buildColDefs";
import { fileToDataURL } from "../../data-parsing/parseUtils";
import { AddProductFormTemplate } from "../../data-parsing/products/AddProductFormTemplate";
import { Product } from "../../data-parsing/products/Product";
import { Order } from "../../data-parsing/orders/Order";

export function Orders() {
  /*   const [query, setQuery] = useState(null);
   */ const { orders, deleteOrder } = useOrders(0);
  const { updateOrder } = useOrder();
  const colDefs = buildColDefs(Order);

  /*
   ! -------------------------------------------------------------------------
   !!!EN api.js, CAMBIAR LA URL DE PRE A LA BASE CUANDO FUNCIONE ESTA SECCIÓN
   ! -------------------------------------------------------------------------
   */

  return (
    <LeftSideMenu active="orders">
      <div className="container">
        <div className="row">
          <div className="col-xs-12">
            <div className="card-box card-tabs m-t-20">
              <h4 className="header-title m-t-0 m-b-40 pull-right">PEDIDOS</h4>

              <div className="fade in m-t-40">
                <DataTable
                  data={orders}
                  colDefs={colDefs}
                  dataId={"Orders"}
                  scrollX={true}
                  allowHiddenColumns={true}
                  dataTemplate={Order}
                  resizable={true}
                  className="table table-bordered panel-group"
                  editElement={updateOrder}
                  /*                   deleteElement={deleteOrder}
                   */
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </LeftSideMenu>
  );
}
export default Orders;
